import React from 'react';
import { AlertCircle } from 'lucide-react';

interface CancelProps {
    onNavigate: (page: string) => void;
}

export const Cancel: React.FC<CancelProps> = ({ onNavigate }) => {
    return (
        <div className="min-h-[70vh] flex flex-col items-center justify-center p-4 bg-gray-50 text-center animate-in fade-in zoom-in duration-500">
            <div className="bg-white p-10 rounded-3xl shadow-xl max-w-lg border border-red-50 flex flex-col items-center">
                <div className="w-24 h-24 bg-red-50 text-red-500 rounded-full flex items-center justify-center mb-6">
                    <AlertCircle size={48} strokeWidth={2.5} />
                </div>
                <h1 className="text-4xl font-serif font-bold text-gray-900 mb-4">Pago Cancelado</h1>
                <p className="text-gray-600 mb-8 max-w-sm">
                    Has cancelado el proceso de pago. No se ha realizado ningún cargo en tu tarjeta. Si tuviste un problema, puedes volver a intentarlo.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 w-full">
                    <button
                        onClick={() => onNavigate('cart')}
                        className="flex-1 bg-[#2C1810] text-white py-3 px-6 rounded-full font-bold hover:opacity-90 transition-opacity shadow-lg"
                    >
                        Revisar Carrito
                    </button>
                    <button
                        onClick={() => onNavigate('home')}
                        className="flex-1 bg-gray-100 text-gray-800 py-3 px-6 rounded-full font-bold hover:bg-gray-200 transition-colors"
                    >
                        Volver al Inicio
                    </button>
                </div>
            </div>
        </div>
    );
};
